import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    depId = '',
    count = -1,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.myOrgDepUser.getDepUserList, {
        depId,
        count,
    }, options);
    if (error) return { error, status };
    return content || {};
};
